export class Message {
  readonly id: string
  readonly device_id: string
  readonly downloaded_at?: Date
  readonly created_at: Date
  readonly expires_at: Date
  readonly first_played_at?: Date
  readonly last_played_at?: Date
  readonly play_count?: number
  readonly size: number
  readonly used_storage_percent: number
  readonly is_mine: boolean
  readonly to_delete: boolean

  constructor (
    id: string,
    device_id: string,
    created_at: Date,
    expires_at: Date,
    size: number,
    used_storage_percent: number,
    is_mine: boolean,
    to_delete: boolean,
    play_count?: number,
    downloaded_at?: Date,
    first_played_at?: Date,
    last_played_at?: Date,
  ) {
    this.id = id
    this.device_id = device_id
    this.created_at = created_at
    this.expires_at = expires_at
    this.play_count = play_count
    this.size = size
    this.used_storage_percent = used_storage_percent
    this.downloaded_at = downloaded_at || undefined
    this.first_played_at = first_played_at || undefined
    this.last_played_at = last_played_at || undefined
    this.is_mine = is_mine || false
    this.to_delete = to_delete || false
  }
}
